import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var WOW: any;

@Injectable({
  providedIn: 'root'
})
export class WowService {
  private wowInstance: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  init(): void {
    if (isPlatformBrowser(this.platformId)) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          try {
            this.wowInstance = new WOW({
              animateClass: 'animate__animated',
              offset: 0,
              live: true
            });
            this.wowInstance.init();

            // Reinitialize on route change
            this.router.events
              .pipe(filter(event => event instanceof NavigationEnd))
              .subscribe(() => {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    try {
                      this.wowInstance.sync(); // refresh WOW.js for new DOM
                    } catch (error) {
                      console.error('❌ WOW.js sync failed:', error);
                    }
                  }, 0);
                });
              });
          } catch (error) {
            console.error('❌ WOW.js initialization failed:', error);
          }
        }, 0);
      });
    }
  }
}